export default __webpack_public_path__ + "static/media/beer-bottle.9e281957.png";